import React from "react"

const SVG = ({
  width = '100%',
  className = '',
  viewBox = '0 0 54 55'
}) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <linearGradient x1="50%" y1="23.8878038%" x2="50%" y2="63.8183594%" id="linearGradient-2">
        <stop stopColor="#F4D235" offset="0%" />
        <stop stopColor="#F4B035" offset="100%" />
      </linearGradient>
      <path d="M108,40.8857143 L92.4839246,51.3282793 C91.1120909,52.2515452 90.3662949,51.7057581 90.815431,50.1188105 L96,31.8 L81.9169123,21.4602092 C80.5820885,20.4801827 80.8455902,19.5886853 82.4864861,19.4703622 L100.5,18.1714286 L106.933398,1.28529102 C107.522466,-0.260872517 108.480568,-0.252909333 109.066602,1.28529102 L115.5,18.1714286 L133.513514,19.4703622 C135.162905,19.5892979 135.417389,20.4805664 134.083088,21.4602092 L120,31.8 L125.184569,50.1188105 C125.634919,51.7100475 124.887603,52.2513393 123.516075,51.3282793 L108,40.8857143 Z" id="path-2" />
      <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-3">
        <feOffset dx="0" dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0" type="matrix" in="shadowOffsetOuter1" />
      </filter>
    </defs>
    <g id="MVP---Android-Lobby-F&amp;F" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Video-Visit---Receipt-w.-Feedback---More-2" transform="translate(-192.000000, -253.000000)">
        <g id="Group-2" transform="translate(20.000000, 66.000000)">
          <g id="Receipt-Copy" transform="translate(0.000000, 102.000000)">
            <g id="Group-3" transform="translate(32.000000, 32.000000)">
              <g id="Group" transform="translate(59.000000, 53.000000)">
                <g id="Star-1">
                  <use fill="black" fillOpacity="1" filter="url(#filter-3)" xlinkHref="#path-2" />
                  <use fill="#F4B035" fillRule="evenodd" xlinkHref="#path-2" />
                  <use fill="url(#linearGradient-2)" fillRule="evenodd" xlinkHref="#path-2" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default SVG